import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { UnpublishEventCommandInput, UnpublishEventCommandOutput } from '@amzn/red-velvet-api';
import { useFeatures, getEnabledFeatures } from '../features';
import { getClient } from '../../utils/getClient';

const MUTATION_PREFIX = ['RedVelvetApi', 'unpublishEvent'];

export function useUnpublishEvent() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation<UnpublishEventCommandOutput, Error, UnpublishEventCommandInput>({
    mutationKey: [...MUTATION_PREFIX],
    mutationFn: (input) => client.unpublishEvent(input),
    retry: false,
  });
}
